import { Component, OnInit } from '@angular/core';
import {CommonDataSource} from "@app/workflow-common/services/CommonDataSource";
import * as moment from "moment";
import {Moment} from "moment";
import {BsModalRef} from "ngx-bootstrap";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";

@Component({
  selector: 'app-history-task-status-modal',
  templateUrl: './history-task-status-modal.component.html',
  styles: []
})
export class HistoryTaskStatusModalComponent implements OnInit {

    task: any;
    title: string;
    startDate: Moment = undefined;
    endDate: Moment = undefined;
    isTaskOnSameDate: boolean = false;
    showSuccessStatus:boolean = false;
    showFailedStatus:boolean = false;
    showSkippedStatus:boolean = false;
    showFullDetails:boolean = false;
    showLessDetails:boolean = false;
    communicationId:any = undefined;
    showContent: string | 'email' | 'sms' = '';
    emailMessageData: any = {};
    smsMessageData: any = {};

    constructor(
        public modalRef: BsModalRef,
        private dataService: WorkflowhttpService) { }

    ngOnInit() {
        const { taskParams, startDate, endDate, status } = this.task;
        this.title = CommonDataSource.capitalize(taskParams.block_name.replace('Block', ''));
        this.startDate = moment.utc( startDate['date'] ).local();
        this.endDate = endDate ? moment.utc( endDate['date'] ).local() : null;
        if(this.endDate) {
            this.isTaskOnSameDate = this.startDate.format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD');
        }
        this.showSuccessStatus = status === 'success';
        this.showFailedStatus = status === 'failed';
        this.showSkippedStatus = status === 'skipped';
        if(taskParams.hasOwnProperty('communicationId')) {
            this.communicationId = taskParams["communicationId"];
        }
        if((taskParams.block_name.startsWith('email') || taskParams.block_name.startsWith('sms')) && this.communicationId) {
            this.showFullDetails = true;
        }
    }

    viewLessDetails() {
        this.showFullDetails = true;
        this.showLessDetails = false;
        this.showContent='';
    }

    viewFullDetails(id: number) {
        if(!id) {
            return;
        }
        const { taskParams } = this.task;
        if(taskParams.block_name.startsWith('email')) {
            if(this.emailMessageData.hasOwnProperty('fromEmail')) {
                this.showFullDetails = false;
                this.showLessDetails = true;
                this.showContent = 'email';
                return;
            }
            this.dataService.getCommunicationEmailDetails(id).subscribe( (resp) => {
                if (!resp) return;
                this.showFullDetails = false;
                this.showLessDetails = true;
                this.showContent = 'email';
                this.emailMessageData['fromEmail'] = resp.fromEmail;
                this.emailMessageData['toEmail'] = resp.toEmail;
                this.emailMessageData['ccEmail'] = resp.ccEmail;
                this.emailMessageData['bccEmail'] = resp.bccEmail;
                this.emailMessageData['subject'] = resp.subject;
                this.emailMessageData['message'] = resp.message;
                this.emailMessageData['sentBy'] = resp.sentBy;
                this.emailMessageData['status'] = resp.status;
            });
        }
        if(taskParams.block_name.startsWith('sms')) {
            this.showFullDetails = false;
            this.showLessDetails = true;
            this.showContent = 'sms';
            this.smsMessageData['recipients'] = taskParams.status.status;
            this.smsMessageData['message'] = taskParams.status.message;
        }
    }

}
